import angular from 'angular';
import ngRoute from 'angular-route';
import angularJwt from 'angular-jwt';
import ngCookies from 'angular-cookies';
import ngTouch from 'angular-touch';
import ngAnimate from 'angular-animate';
import ngSanitize from 'angular-sanitize';
import 'babel-polyfill';
import moment from 'moment-timezone';

var configFile = require('../config/index.js');

var config = configFile.environments[ENVIRONMENT],
    smooth = config;
Raven.config("https://1c13202c414b4b2aafc8917ea76b1a79@o485970.ingest.sentry.io/5542054").install();
window.smooth = config;
window.moment = moment;
var calendarApp = angular.module('calendarApp', [// External libraries
'ngRoute', 'angular-jwt', 'ngCookies', 'ngTouch', 'ngAnimate', 'ngSanitize', 'MainController', // Services
'service.calendarService', // Directives
'directive.dayContainer', 'directive.yogaShiftContainer', 'directive.throbber', 'directive.tooltip', 'directive.stripeCardPayment', 'directive.stripeCreateMembership', 'directive.stripeupdatepaymentmethod', 'directive.stripepayinvoice', // Filters
'filter.smoothtime', 'filter.smoothdatetime', 'filter.smoothdate', // Services
'service.paymentOptionService']).config(["$routeProvider", "$locationProvider", function ($routeProvider, $locationProvider) {
  $routeProvider.when('/', {
    template: ' ',
    controller: 'RootController'
  }) // Calendar one
  .when('/class', {
    templateUrl: smooth.calendar_url + '/partials/class-calendar.html',
    controller: 'HomeController',
    controllerAs: 'home'
  }).when('/home', {
    templateUrl: smooth.calendar_url + '/partials/class-calendar.html',
    controller: 'HomeController',
    controllerAs: 'home'
  }) // Calendar two
  .when('/service', {
    templateUrl: smooth.calendar_url + '/partials/service-calendar.html',
    controller: 'ServiceCalendarController',
    controllerAs: 'serv'
  }).when('/service-availability/:serviceid/:date', {
    templateUrl: smooth.calendar_url + '/partials/service-availability.html',
    controller: 'ServiceAvailabilityController',
    controllerAs: 'choose'
  }).when('/login', {
    template: '<customer-login></customer-login>'
  }).when('/register', {
    template: '<customer-login></customer-login>'
  }).when('/forgot-password', {
    templateUrl: smooth.calendar_url + '/partials/forgot-password.html',
    controller: 'ForgotPasswordController',
    controllerAs: 'fog'
  }).when('/reset-password/:resetkey', {
    templateUrl: smooth.calendar_url + '/partials/reset-password.html',
    controller: 'ResetPasswordController',
    controllerAs: 'res'
  }).when('/chooseslots', {
    templateUrl: smooth.calendar_url + '/partials/choose-slots.html',
    controller: 'ChooseSlotsController',
    controllerAs: 'choose'
  }).when('/futureslots', {
    templateUrl: smooth.calendar_url + '/partials/future-slots.html',
    controller: 'FutureSlotsController',
    controllerAs: 'future'
  }).when('/overbooked/:referrer', {
    templateUrl: smooth.calendar_url + '/partials/overbooked.html',
    controller: 'OverbookedController',
    controllerAs: 'over'
  }).when('/preview', {
    templateUrl: smooth.calendar_url + '/partials/preview.html',
    controller: 'PreviewController',
    controllerAs: 'preview'
  }).when('/review', {
    templateUrl: smooth.calendar_url + '/partials/review.html',
    controller: 'ReviewController',
    controllerAs: 'review'
  }).when('/confirmrego', {
    templateUrl: smooth.calendar_url + '/partials/confirm-rego.html',
    controller: 'ConfirmRegoController',
    controllerAs: 'rego'
  }).when('/bookingform', {
    templateUrl: smooth.calendar_url + '/partials/booking-form.html',
    controller: 'BookingFormController',
    controllerAs: 'book'
  }).when('/choose-payment', {
    templateUrl: smooth.calendar_url + '/partials/choose-payment.html',
    controller: 'ChoosePaymentController',
    controllerAs: 'pay'
  }).when('/payment', {
    templateUrl: smooth.calendar_url + '/partials/payment.html',
    controller: 'PaymentController',
    controllerAs: 'pay'
  }).when('/confirm', {
    templateUrl: smooth.calendar_url + '/partials/confirm.html',
    controller: 'ConfirmController',
    controllerAs: 'confirm'
  }).when('/account/appointments', {
    templateUrl: smooth.calendar_url + '/partials/customer-account-appointments.html',
    controller: 'CustomerAccountAppointmentsController',
    controllerAs: 'account'
  }).when('/account/transactions', {
    templateUrl: smooth.calendar_url + '/partials/customer-account-transactions.html',
    controller: 'CustomerAccountTransactionsController',
    controllerAs: 'account'
  }).when('/account/packages', {
    templateUrl: smooth.calendar_url + '/partials/customer-account-packages.html',
    controller: 'CustomerAccountPackagesController',
    controllerAs: 'account'
  }).when('/account/memberships', {
    templateUrl: smooth.calendar_url + '/partials/customer-account-memberships.html',
    controller: 'CustomerAccountMembershipsController',
    controllerAs: 'member'
  }).when('/account/update-payment-method', {
    templateUrl: smooth.calendar_url + '/partials/customer-account-update-payment.html',
    controller: 'CustomerAccountUpdatePaymentController',
    controllerAs: 'update'
  }).when('/account/manage-invoices', {
    templateUrl: smooth.calendar_url + '/partials/customer-account-manage-invoices.html',
    controller: 'CustomerAccountManageInvoicesController',
    controllerAs: 'update'
  }).when('/account/eugdpr', {
    templateUrl: smooth.calendar_url + '/partials/customer-eugdpr.html',
    controller: 'EUGDPRController',
    controllerAs: 'eugdp'
  }).when('/account', {
    templateUrl: smooth.calendar_url + '/partials/customer-account.html',
    controller: 'CustomerAccountController',
    controllerAs: 'rego'
  }).when('/waitlist/:slotid/:token', {
    templateUrl: smooth.calendar_url + '/partials/waitlist.html',
    controller: 'WaitlistController',
    controllerAs: 'wait'
  }).when('/superlogin', {
    templateUrl: smooth.calendar_url + '/partials/super-login.html',
    controller: 'SuperloginController',
    controllerAs: 'log'
  }).otherwise({
    redirectTo: '/'
  }); // $locationProvider.html5Mode(true); Not currently working

  $locationProvider.hashPrefix('');
}]) // .constant('BASE_URL', smooth.base_url)
.constant('CALENDAR_URL', smooth.calendar_url).constant('API_URL', smooth.api_url) // Monitor all requests and responses, check for and assign JWT token.
.factory('AuthIntercept', ["$window", "$rootScope", "$location", "API_URL", "jwtHelper", function ($window, $rootScope, $location, API_URL, jwtHelper) {
  var authInterceptor = {
    request: function request(req) {
      var token = localStorage.getItem('calendar-jwt-token'); // Append token to header if it exists. Currently occurs on
      // every request.

      if (token) {
        req.headers['calendar-x-access-token'] = token; // Get user info from the token and store globally.

        var payload = jwtHelper.decodeToken(token); // Check for token expiry

        if (moment.unix(payload.exp).isBefore(moment())) {
          delete $rootScope.customerInfo;
          localStorage.removeItem('calendar-jwt-token');
          return req;
        }

        $rootScope.customerInfo = payload.customer && payload.customer;
      }

      return req;
    },
    response: function response(res) {
      // Token sent. Store it
      if (res.data.success && res.data.token) {
        localStorage.setItem('calendar-jwt-token', res.data.token);
      }

      return res;
    },
    responseError: function responseError(rejection) {
      if (rejection.status === 401) {
        // Remove existing token
        localStorage.removeItem('calendar-jwt-token');
        $location.path('/login');
        return;
      }

      return rejection;
    }
  };
  return authInterceptor;
}]).config(["$httpProvider", function ($httpProvider) {
  $httpProvider.interceptors.push("AuthIntercept");
}]) // This function is helpful for global settings and settings specific to the page / context.
.run(["$rootScope", "$route", "$location", "jwtHelper", "$timeout", "$cookies", function ($rootScope, $route, $location, jwtHelper, $timeout, $cookies) {
  $rootScope.$on('$routeChangeSuccess', function (e, current, pre) {
    var cookie = $cookies.get('smoothbook-cookie-consent') || localStorage.getItem('smoothbook-cookie-consent');

    if (!cookie) {
      $timeout(function () {
        $('#cookie-consent-modal').modal();
      }, 0);
    } else {
      if (!$rootScope.cookieConsent) {
        window.dataLayer = window.dataLayer || [];

        window.gtag = function () {
          dataLayer.push(arguments);
        };

        gtag('js', new Date());
        gtag('config', 'UA-172578396-1');
        $rootScope.cookieConsent = true;
      } // Don't start analytics or adsense without cookie consent


      gtag && gtag('config', 'UA-172578396-1', {
        'page_path': location
      });

      try {
        if (smooth.env !== 'dev' && !smooth.subscribed) {
          (adsbygoogle = window.adsbygoogle || []).push({});
        }
      } catch (e) {}
    }

    var location = $location.path();
    var token = localStorage.getItem('calendar-jwt-token');
    $rootScope.authorising = false;

    if (token) {
      // Get user info from the token and store globally.
      var payload = jwtHelper.decodeToken(token);
      $rootScope.customerInfo = payload.customer;
    }

    $rootScope.safeApply = function safeApply(operation) {
      var phase = this.$root.$$phase;

      if (phase !== '$apply' && phase !== '$digest') {
        this.$apply(operation);
        return;
      }

      if (operation && typeof operation === 'function') operation();
    };

    var original = $location.path;

    $location.path = function (path, reload) {
      if (reload === false) {
        var lastRoute = $route.current;
        var un = $rootScope.$on('$locationChangeSuccess', function () {
          $route.current = lastRoute;
          un();
        });
      }

      return original.apply($location, [path]);
    };
  });
}]);
export default calendarApp;